export default {
  namespaced: true,
  victronenergy: {
    title: "VictronEnergy",
    master_account: {
      title: "Cuenta Maestra",
      name: "Nombre",
      description: "Descripción",
      api_email: "Correo API",
      api_password: "Contraseña API",
      api_server: "Servidor API",
      token: "Token",
      url_mqtt: "Url mqtt",
    },
    sites: {
      title: "Sitios",
      name: "Nombre",
      description: "Descripción",
      is_active: "Está Activo",
      timezone: "Zona Horaria",
      status: "Estado",
      has_mains: "Tiene Red Eléctrica",
      has_generator: "Tiene Generador",
      device_icon: "Icono del Dispositivo",
      favorite: "Favorito",
      devices: "Dispositivos",
    },
    devices: {
      title: "Dispositivos",
      name: "Nombre",
      product_name: "Nombre del Producto",
      product_code: "Código del Producto",
      machine_serial_number: "Número de Serie",
      firmware_version: "Versión de Firmware",
      device_class: "Clase del Dispositivo",
      last_connection: "Última Conexión",
      gui_v2_status: "Estado GUI V2",
      has_victron_connect: "Tiene Victron Connect",
    }
  }
};
